module.exports = __webpack_public_path__ + "resources/img/img_ontune_vm_sms_m_en.fa8b4ff3f4cbe04290b9f8668098796b.png";